import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const PURCHASERS = [{
  name: 'Alejandro',
  city: 'Buenos Aires'
}, {
  name: 'Matías',
  city: 'Córdoba'
}, {
  name: 'Joaquín',
  city: 'Rosario'
}, {
  name: 'Tomás',
  city: 'Mendoza'
}, {
  name: 'Sebastián',
  city: 'La Plata'
}, {
  name: 'Diego',
  city: 'Mar del Plata'
}, {
  name: 'Franco',
  city: 'Tucumán'
}, {
  name: 'Pablo',
  city: 'Santa Fe'
}, {
  name: 'Gonzalo',
  city: 'Salta'
}, {
  name: 'Ramiro',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchaser, setCurrentPurchaser] = useState(PURCHASERS[0]);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, [isDismissed]);
  const showNextPopup = () => {
    if (isDismissed) return;
    // Pick a random purchaser
    const randomPurchaser = PURCHASERS[Math.floor(Math.random() * PURCHASERS.length)];
    setCurrentPurchaser(randomPurchaser);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (between 8-12 seconds from now)
      if (!isDismissed) {
        const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
        setTimeout(showNextPopup, nextDelay);
      }
    }, 4000);
  };
  if (isDismissed) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out transform ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-[120%] opacity-0'}`} data-id="element-363">
      <div className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 pr-10 flex items-center gap-3 max-w-sm relative" data-id="element-364">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-365">
          <XIcon size={16} data-id="element-366" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-367">
          <CheckIcon className="text-green-600" size={20} data-id="element-368" />
        </div>

        <div data-id="element-369">
          <p className="text-sm text-gray-800" data-id="element-370">
            <span className="font-bold" data-id="element-371">{currentPurchaser.name}</span> de{' '}
            {currentPurchaser.city}
          </p>
          <p className="text-xs text-gray-500 mt-0.5" data-id="element-372">
            acaba de comprar el Sistema Completo
          </p>
        </div>
      </div>
    </div>;
}